/* eslint-disable react/jsx-props-no-multi-spaces */
import React from 'react'
import ButtonPrimary from 'components/ButtonPrimary'
import ContentBox from 'components/ContentBox'
import { STYLES_ALIGN_ITEMS, STYLES_JUSTIFY_CONTENT, STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'

class ErrorBoundary extends React.Component {
  static propTypes = {
    isSmallScreen: PropTypes.bool
  }

  render () {
    return (
      <ContentBox
        style={{
          textAlign: 'center',
          marginTop: STYLES_MARGIN.BIG,
          marginLeft: this.props.isSmallScreen
            ? undefined
            : STYLES_MARGIN.BIG,
          marginRight: this.props.isSmallScreen
            ? undefined
            : STYLES_MARGIN.BIG,
          alignItems: STYLES_ALIGN_ITEMS.CENTER,
          justifyContent: STYLES_JUSTIFY_CONTENT.CENTER
        }}
      >
        <p>An error occurred, please reload the app.</p>
        <ButtonPrimary

          onClick={() => window.location.reload()}
        >
          Reload
        </ButtonPrimary>
      </ContentBox>
    )
  }
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(ErrorBoundary)
